//mushroom-guest-session.ts

const mushroomGuestSessionKey = "mushroomGuestSession";

export function isMushroomGuestEnabled(): boolean {
  return process.env.REACT_APP_MUSHROOM_GUEST_ENABLED === "true";
}

export function getMushroomGuestSession(): { expiresAt: number } | null {
  try {
    const raw = window.sessionStorage.getItem(mushroomGuestSessionKey);
    if (!raw) {
      return null;
    }

    return JSON.parse(raw) as { expiresAt: number };
  } catch (e) {
    return null;
  }
}

export function isMushroomGuestActive(): boolean {
  if (!isMushroomGuestEnabled()) {
    return false;
  }

  const session = getMushroomGuestSession();
  if (!session?.expiresAt) {
    return false;
  }

  return Date.now() < session.expiresAt;
}

export function setMushroomGuestSession(): void {
  const daysRaw = process.env.REACT_APP_MUSHROOM_GUEST_DAYS || "7";
  const days = Number(daysRaw);

  const expiresAt =
    Date.now() + (Number.isFinite(days) ? days : 7) * 24 * 60 * 60 * 1000;

  window.sessionStorage.setItem(
    mushroomGuestSessionKey,
    JSON.stringify({ expiresAt }),
  );
}

export function clearMushroomGuestSession(): void {
  window.sessionStorage.removeItem(mushroomGuestSessionKey);
}

export function validateMushroomGuestCode(code: string): boolean {
  const expected = process.env.REACT_APP_MUSHROOM_GUEST_CODE || "";
  return expected.length > 0 && code.trim() === expected;
}
